(function () {
  'use strict';

  var PENDING_KEY = '__bcPendingAdd';

  function getCartIcon() {
    return document.getElementById('cart-icon-bubble');
  }

  function flyToCart(button) {
    var icon = getCartIcon();
    if (!icon) return;
    var cartRect = icon.getBoundingClientRect();
    var startRect = button.getBoundingClientRect();
    if (!cartRect.width || !startRect.width) return;

    var startX = startRect.left + startRect.width / 2;
    var startY = startRect.top + startRect.height / 2;
    var dx = (cartRect.left + cartRect.width / 2) - startX;
    var dy = (cartRect.top + cartRect.height / 2) - startY;

    var flyer = document.createElement('div');
    flyer.className = 'bc-fly-car';
    flyer.setAttribute('aria-hidden', 'true');
    flyer.textContent = '🚗';
    flyer.style.left = (startX - 11) + 'px';
    flyer.style.top = (startY - 11) + 'px';
    document.body.appendChild(flyer);

    var supportsMotionPath =
      window.CSS && CSS.supports && CSS.supports('offset-path', 'path("M0 0")');

    function cleanup(delay) {
      setTimeout(function () {
        flyer.remove();
        icon.classList.add('bc-cart-bounce');
        setTimeout(function () {
          icon.classList.remove('bc-cart-bounce');
        }, 420);
      }, delay);
    }

    if (supportsMotionPath) {
      // Arc the flight path upward via a quadratic Bezier motion path instead
      // of a straight-line translate, so the icon visibly "hops" to the cart.
      var arcHeight = Math.min(130, Math.max(40, Math.abs(dx) * 0.35));
      var midX = dx / 2;
      var midY = dy / 2 - arcHeight;
      flyer.style.offsetPath = 'path("M 0 0 Q ' + midX + ' ' + midY + ' ' + dx + ' ' + dy + '")';
      flyer.style.offsetRotate = '0deg';
      flyer.style.offsetDistance = '0%';

      requestAnimationFrame(function () {
        flyer.style.transition =
          'offset-distance 700ms cubic-bezier(0.3, 0.1, 0.3, 1), opacity 700ms ease 350ms, transform 700ms ease';
        flyer.style.offsetDistance = '100%';
        flyer.style.opacity = '0';
        flyer.style.transform = 'scale(0.35) rotate(25deg)';
      });

      cleanup(720);
    } else {
      requestAnimationFrame(function () {
        flyer.style.transition = 'transform 600ms cubic-bezier(0.2, 0.8, 0.2, 1), opacity 600ms ease';
        flyer.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.3) rotate(20deg)';
        flyer.style.opacity = '0';
      });

      cleanup(620);
    }
  }

  function buildConfirmationMessage(data) {
    var rating = parseFloat(data.rating);
    var count = parseInt(data.count, 10);

    if (!isNaN(rating) && rating > 0 && !isNaN(count) && count > 0) {
      return '⭐ ' + rating.toFixed(1).replace('.', ',') + '/5 von ' + count + ' zufriedenen Schraubern – gute Wahl!';
    }

    var fallbacks = [
      'Gute Entscheidung! 🎉 Viel Spaß beim Aufbauen.',
      '🏆 Starke Wahl für deinen Schreibtisch!',
      'Nice! 🔧 Das wird ein tolles Modell.'
    ];
    return fallbacks[Math.floor(Math.random() * fallbacks.length)];
  }

  function showConfirmation(drawerEl) {
    var pending = window[PENDING_KEY];
    if (!pending || !drawerEl) return;
    window[PENDING_KEY] = null;

    var slot = drawerEl.querySelector('#CartDrawer-Confirmation');
    if (!slot) return;

    slot.textContent = buildConfirmationMessage(pending);
    slot.hidden = false;
    slot.classList.remove('is-visible');
    void slot.offsetWidth;
    slot.classList.add('is-visible');
  }

  document.addEventListener(
    'click',
    function (evt) {
      var button = evt.target.closest('product-form button[type="submit"]');
      if (!button || button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true') return;

      window[PENDING_KEY] = {
        title: button.dataset.productTitle || '',
        rating: button.dataset.reviewRating || '',
        count: button.dataset.reviewCount || ''
      };

      flyToCart(button);
    },
    true
  );

  function applyPatch(CartDrawerClass) {
    if (!CartDrawerClass || CartDrawerClass.__bcPatched) return;

    var proto = CartDrawerClass.prototype;

    var originalRenderContents = proto.renderContents;
    proto.renderContents = function (parsedState) {
      originalRenderContents.call(this, parsedState);
      showConfirmation(this);
    };

    // Toggle a body flag so CSS can hide app widgets (chat, badges) that would
    // otherwise sit on top of the checkout button on small screens.
    var originalOpen = proto.open;
    proto.open = function (triggeredBy) {
      originalOpen.call(this, triggeredBy);
      document.body.classList.add('bc-cart-open');
    };

    var originalClose = proto.close;
    proto.close = function () {
      originalClose.call(this);
      document.body.classList.remove('bc-cart-open');
    };

    CartDrawerClass.__bcPatched = true;
  }

  function patchCartDrawer() {
    if (!window.customElements) return;
    var existing = customElements.get('cart-drawer');
    if (existing) {
      applyPatch(existing);
    } else {
      customElements.whenDefined('cart-drawer').then(function () {
        applyPatch(customElements.get('cart-drawer'));
      });
    }
  }

  patchCartDrawer();
})();

(function () {
  'use strict';

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('.bc-topup__add');
    if (!btn || btn.disabled) return;
    evt.preventDefault();

    var variantId = btn.getAttribute('data-bc-variant-id');
    var drawer = document.querySelector('cart-drawer');
    if (!variantId || !drawer) return;

    btn.disabled = true;

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append(
      'sections',
      drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
    );
    formData.append('sections_url', window.location.pathname);

    fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (parsed) {
        if (parsed.status) { btn.disabled = false; return; }
        drawer.renderContents(parsed);
      })
      .catch(function () { btn.disabled = false; });
  });
})();
